import gql from "graphql-tag";

// Each count uses the same QueryInput and fixed server filters as its row endpoint.
export const getAnnouncementCount = gql`
  query getAnnouncementCount($query: QueryInput) {
    count: getAnnouncementCount(query: $query)
  }
`;

export const getBusinessSegmentCount = gql`
  query getBusinessSegmentCount($query: QueryInput) {
    count: getBusinessSegmentCount(query: $query)
  }
`;

export const getCatalystCount = gql`
  query getCatalystCount($query: QueryInput) {
    count: getCatalystCount(query: $query)
  }
`;

export const getCreditDailyCount = gql`
  query getCreditDailyCount($query: QueryInput) {
    count: getCreditDailyCount(query: $query)
  }
`;

export const getCreditQuarterlyCount = gql`
  query getCreditQuarterlyCount($query: QueryInput) {
    count: getCreditQuarterlyCount(query: $query)
  }
`;

export const getDebtCount = gql`
  query getDebtCount($query: QueryInput) {
    count: getDebtCount(query: $query)
  }
`;

export const getDueDiligenceCount = gql`
  query getDueDiligenceCount($query: QueryInput) {
    count: getDueDiligenceCount(query: $query)
  }
`;

export const getESGCount = gql`
  query getESGCount($query: QueryInput) {
    count: getESGCount(query: $query)
  }
`;

export const getEstimateCount = gql`
  query getEstimateCount($query: QueryInput) {
    count: getEstimateCount(query: $query)
  }
`;

export const getFundamentalCount = gql`
  query getFundamentalCount($query: QueryInput) {
    count: getFundamentalCount(query: $query)
  }
`;

export const getFundamentalSignalCount = gql`
  query getFundamentalSignalCount($query: QueryInput) {
    count: getFundamentalSignalCount(query: $query)
  }
`;

export const getFundingCount = gql`
  query getFundingCount($query: QueryInput) {
    count: getFundingCount(query: $query)
  }
`;

export const getHolderCount = gql`
  query getHolderCount($query: QueryInput) {
    count: getHolderCount(query: $query)
  }
`;

export const getLeaseCount = gql`
  query getLeaseCount($query: QueryInput) {
    count: getLeaseCount(query: $query)
  }
`;

export const getOptimizedCompositeCount = gql`
  query getOptimizedCompositeCount($query: QueryInput) {
    count: getOptimizedCompositeCount(query: $query)
  }
`;

export const getPropertyCount = gql`
  query getPropertyCount($query: QueryInput) {
    count: getPropertyCount(query: $query)
  }
`;

export const getPurchaseCount = gql`
  query getPurchaseCount($query: QueryInput) {
    count: getPurchaseCount(query: $query)
  }
`;

export const getRatingCount = gql`
  query getRatingCount($query: QueryInput) {
    count: getRatingCount(query: $query)
  }
`;

export const getRatingDetailCount = gql`
  query getRatingDetailCount($query: QueryInput) {
    count: getRatingDetailCount(query: $query)
  }
`;

export const getRentCount = gql`
  query getRentCount($query: QueryInput) {
    count: getRentCount(query: $query)
  }
`;

export const getSaleCount = gql`
  query getSaleCount($query: QueryInput) {
    count: getSaleCount(query: $query)
  }
`;

export const getScoringCount = gql`
  query getScoringCount($query: QueryInput) {
    count: getScoringCount(query: $query)
  }
`;

export const getSentimentCount = gql`
  query getSentimentCount($query: QueryInput) {
    count: getSentimentCount(query: $query)
  }
`;

export const getSupplyChainCount = gql`
  query getSupplyChainCount($query: QueryInput) {
    count: getSupplyChainCount(query: $query)
  }
`;

export const getTradeCount = gql`
  query getTradeCount($query: QueryInput) {
    count: getTradeCount(query: $query)
  }
`;

export const getTradeSignalCount = gql`
  query getTradeSignalCount($query: QueryInput) {
    count: getTradeSignalCount(query: $query)
  }
`;

export const getValuationCount = gql`
  query getValuationCount($query: QueryInput) {
    count: getValuationCount(query: $query)
  }
`;
